/** The source language. Every other language must define exactly these keys (the types enforce it). */
export const enUS = {
    // app bar
    'app.name': 'Tomato Pop',
    'app.support': 'Support',
    'app.supportAria': 'Support Tomato Pop',
    'app.customize': 'Customize your tomato',
    'app.language': 'Language',
    'app.theme': 'Theme',
    'app.themeLight': 'Light',
    'app.themeDark': 'Dark',
    'app.themeSystem': 'System',
    'app.themeDaytime': 'Auto (7am-7pm)',
    'app.settings': 'Settings',
    'settings.timer': 'Timer',
    'app.pullToRefresh': 'Pull down to refresh',
    'app.backToTomato': '← Back to the tomato',
    'app.getOnMobile':
        'Take your tomato everywhere, with haptics and a one-time lifetime unlock that removes all ads.',

    // timer
    'timer.focus': 'Focus',
    'timer.short_one': 'Short break',
    'timer.short_other': 'Short break',
    'timer.long': 'Long break',
    'timer.mode': 'Timer mode',
    'timer.start': 'Start',
    'timer.pause': 'Pause',
    'timer.resume': 'Resume',
    'timer.reset': 'Reset',
    'timer.resetAria': 'Reset timer',
    'timer.skip': 'Skip',
    'timer.skipAria': 'Skip to next',

    // page
    'page.today': '🍅 {count} today',
    'page.streak': '🔥 {count} day streak',
    'page.listening': '🎧 Listening',
    'page.plusOne': '+1 🍅',
    'page.breakOver': 'Break over!',

    // drawer
    'drawer.title': 'Make it yours',
    'drawer.close': 'Close customization',
    'drawer.glowColor': 'Glow color',
    'drawer.glowMatch': 'Match tomato color',
    'drawer.tab.model': '🍅 Model',
    'drawer.tab.color': '🎨 Color',
    'drawer.tab.face': '😎 Face',
    'drawer.tab.vines': '🌿 Vines',
    'drawer.tab.scene': '🏞 Scene',
    'drawer.tab.finish': '💥 Finish',
    'drawer.tab.timer': '⏱ Timer',
    'drawer.useColor': 'Use color {color}',
    'drawer.hex': 'Hex color',
    'drawer.model': 'Base model',
    'drawer.eyes': 'Eyes',
    'drawer.mouth': 'Mouth',
    'drawer.hat': 'Hat',
    'drawer.necklace': 'Necklace',
    'drawer.vine': 'Vine design',
    'drawer.scene': 'Scene',
    'drawer.whenEnds': 'When the timer ends...',
    'drawer.try': 'Try',
    'drawer.preview': 'Preview {name}',
    'drawer.minutes': 'Minutes',
    'drawer.minutes.focus': 'Focus',
    'drawer.minutes.short': 'Short',
    'drawer.minutes.long': 'Long',
    'drawer.party': 'Party mode: dance to the music',
    'drawer.partyHint':
        'Listens through the microphone to whatever is playing nearby. Nothing is recorded or sent.',
    'drawer.partyFailed':
        'Could not reach the microphone. Allow it in the browser or phone settings to try again.',
    'drawer.alarm': 'Alarm sound',
    'drawer.alarm.preview': 'Play the alarm sound',
    'drawer.alarm.classic': 'Classic beeps',
    'drawer.alarm.chime': 'Chimes',
    'drawer.alarm.bell': 'Bell',
    'drawer.alarm.gentle': 'Gentle',
    'drawer.alarm.siren': 'Siren',
    'drawer.alarm.system': 'Phone alarm ringtone',
    'drawer.alarm.hint': 'Used when any timer ends: focus, break or roulette.',
    'drawer.lockScreen': 'Full-screen alarm on the lock screen',
    'drawer.lockScreenHint':
        'Like a clock app: a big alarm screen over the lock screen. When the phone is unlocked you get a notification instead.',
    'drawer.alarmFix': 'Fix',
    'drawer.alarmProblem.notifications':
        'Notifications are off for Tomato Pop, so the alarm screen and its buttons cannot show.',
    'drawer.alarmProblem.channel':
        'The "Timer alarm" notification category was turned down in system settings, so the alarm cannot take over the screen. Set it to urgent / pop on screen.',
    'drawer.alarmProblem.fullScreen':
        'Android is blocking full-screen alarms for this app. Allow "Full screen notifications" to see the tomato when the phone is locked.',
    'drawer.webNotify.denied':
        "Notifications are blocked for this site, so you will not be alerted when the timer ends in a background tab. Allow them in your browser's site settings.",
    'drawer.webNotify.ask':
        'Allow notifications to be alerted when the timer ends in a background tab.',
    'drawer.webNotify.enable': 'Allow',
    'notify.startRest': 'Start rest',
    'notify.restart': 'Restart',
    'notify.dismiss': 'OK',
    'drawer.sound': 'Sound effects',
    'drawer.developer': 'Developer',
    'drawer.skipLast': 'Skip to last 10 seconds',

    // options
    'opt.none': 'None',
    'opt.model.classic': 'Classic',
    'opt.model.timer': 'Kitchen timer',
    'opt.eyes.googly': 'Googly',
    'opt.eyes.angry': 'Angry',
    'opt.eyes.shades': 'Shades',
    'opt.eyes.hearts': 'Hearts',
    'opt.mouth.smile': 'Smile',
    'opt.mouth.tongue': 'Tongue',
    'opt.mouth.mustache': 'Mustache',
    'opt.hat.party': 'Party',
    'opt.hat.tophat': 'Top hat',
    'opt.hat.crown': 'Crown',
    'opt.hat.wizard': 'Wizard',
    'opt.neck.tshirt': 'T-shirt',
    'opt.neck.pearls': 'Pearls',
    'opt.neck.bling': '2ma2 bling',
    'opt.vine.classic': 'Classic',
    'opt.vine.ivy': 'Ivy',
    'opt.vine.blossom': 'Blossom',
    'opt.bg.default': 'Glow',
    'opt.bg.beach': 'Beach',
    'opt.bg.space': 'Space',
    'opt.bg.farm': 'Farm',
    'opt.done.explode': 'Explode',
    'opt.done.explode.blurb': 'Splat! Bits and accessories everywhere.',
    'opt.done.roll': 'Roll away',
    'opt.done.roll.blurb': 'Rolls off screen, a fresh one rolls in.',
    'opt.done.rocket': 'Rocket',
    'opt.done.rocket.blurb': 'Blasts off into orbit.',

    // ads
    'ads.advertisement': 'Advertisement',
    'ads.footerPreview': 'Footer ad preview',
    'ads.breakTitle': 'Ad break · keeps Tomato Pop free',
    'ads.breakPreview': 'Ad break preview',
    'ads.continue': 'Continue',
    'ads.continueIn': 'Continue in {seconds}s',
    'footer.about': 'About',
    'footer.privacy': 'Privacy',

    // support
    'support.title': 'Support Tomato Pop',
    'support.intro':
        'Tomato Pop is a tiny, silly app made by one person. Ads and support keep it alive and growing new hats.',
    'support.owned':
        'You have lifetime access: no ads, ever. Thank you, you absolute legend!',
    'support.lifetime': 'Remove ads forever · {price}',
    'support.lifetimeHint':
        'One payment, no subscription. Removes all ads for good, on this store account.',
    'support.restore': 'Restore a previous purchase',
    'support.coffee': '☕ Buy me a coffee',
    'support.pix': '🇧🇷 Pix (Mercado Pago)',
    'support.noLink':
        'The donation link is not set up yet (REACT_APP_DONATE_URL).',
    'support.noAds':
        'Want no ads at all? The phone app has a one-time lifetime unlock.',
    'support.noAccount':
        'No account, no sign-up. Your tomato lives on this device.',
    'support.about': 'About',
    'support.privacy': 'Privacy policy',
    'support.close': 'Close',
    'goal.heading': 'Community goal: {item}',
    'goal.how': 'When the jar is full, everyone gets it, supporters or not.',
    'goal.progress': '{raised} of {target}',
    'goal.funded': 'Funded! Unlocked for everyone 🎉',
    'goal.locked': 'Unlocks when funded',
    'goal.ledger': 'Where it came from',
    'goal.empty': 'No contributions yet. Be the first!',

    // privacy (the app's own ads section; the rest comes from the core)

    // about
    'about.title': 'About Tomato Pop',
    'about.intro':
        'Tomato Pop is a free pomodoro timer with a personality. You work in focused sprints, and a 3D tomato keeps you company: it ripens and glows as the time runs down, and when you finish it celebrates in a way you choose. Dress it up, pick its color, and make focusing a little more fun.',
    'about.whatTitle': 'What is the pomodoro technique?',
    'about.what1':
        'The pomodoro technique was created by Francesco Cirillo in the late 1980s and named after the tomato-shaped kitchen timer he used as a student. The idea is simple: pick one task, work on it with full attention for 25 minutes, then take a short break. After four sessions, take a longer break. The fixed, short intervals make it easier to start, protect you from distractions, and give you a steady rhythm of small wins.',
    'about.what2':
        'Tomato Pop follows the classic pattern by default: 25 minutes of focus, a 5 minute short break, and a 15 minute long break after every fourth focus session. You can change all three lengths in the customize panel.',
    'about.customTitle': 'What you can customize',
    'about.custom1':
        'Your tomato’s color, from a color picker or ready-made swatches.',
    'about.custom2':
        'Eyes (googly, angry, shades, hearts), a mouth (smile, tongue, mustache), a hat (party hat, top hat, crown) and a necklace (T-shirt, pearls, bling).',
    'about.custom3':
        'A vine design (classic, ivy or blossom) and a scene (beach, space or farm).',
    'about.custom4':
        'How it celebrates when a session ends: it can explode, roll away, or blast off like a rocket, each with its own sounds.',
    'about.custom5':
        'Timer lengths, sound effects and a party mode that dances to the music.',
    'about.tipsTitle': 'Tips for better focus sessions',
    'about.tip1':
        'Decide what you will work on before you press start, and write it down.',
    'about.tip2':
        'Silence notifications and keep your phone out of reach for the 25 minutes.',
    'about.tip3':
        'If a distraction pops into your head, jot it on paper and return to the task.',
    'about.tip4':
        'Take the break for real: stand up, stretch, drink some water, look away from the screen.',
    'about.tip5':
        'Cut big tasks into pieces that fit into one or two sessions.',
    'about.faqTitle': 'Questions',
    'about.q1': 'Do I need an account?',
    'about.a1':
        'No. Tomato Pop has no accounts and no sign-up. Your tomato, settings and daily count are stored only on your device.',
    'about.q2': 'Does it keep working in a background tab?',
    'about.a2':
        'Yes. The timer follows the real clock, so it stays accurate even if your browser slows down a background tab.',
    'about.q3': 'Why are there ads?',
    'about.a3':
        'Tomato Pop is made by one person and is free to use. Ads and support from users keep it running. The phone app has a one-time lifetime unlock that removes every ad.',
    'about.q4': 'How can I support it?',
    'about.a4a': 'Use the Support button at the top of the page. See our',
    'about.a4link': 'privacy policy',
    'about.a4b': 'for how data and ads are handled.',
    'about.q5': 'How do I get in touch?',
    'about.a5': 'Write to',
    'app.getOnMobileButton': 'Get on mobile',
    'app.getOnMobileTitle': 'Get {name} on your phone',
    'app.close': 'Close',
    'store.googlePlay': 'Get it on Google Play',
    'store.appStore': 'Get it on the App Store',
    'store.comingSoon': 'Coming soon',
    'store.comingSoonGooglePlay': 'Coming soon to Google Play',
    'store.comingSoonAppStore': 'Coming soon to the App Store',
    'scene.farmSign': 'TOMATO FARM',
    'privacy.consent':
        'In the EU, the UK and Switzerland we ask for your consent before showing ads, through the Google consent form, in the Android app and on the website. You can change your choice at any time: in the Android app with the button below, on the website with the privacy settings button that Google shows.',
    'privacy.adChoices': 'Ad privacy choices',
    'privacy.title': 'Privacy Policy',
    'privacy.intro':
        'Tomato Pop is a small app that respects your privacy. This policy explains what is stored, what is shared and why. By using Tomato Pop you agree to it.',
    'privacy.deviceTitle': 'What stays on your device',
    'privacy.p1':
        'Tomato Pop has no accounts and no server of its own. Your tomato, settings, language and daily stats are stored only on your device and never sent to us.',
    'privacy.adsTitle': 'Advertising',
    'privacy.p2a':
        'The free app shows ads from Google (AdSense on the web, AdMob in the phone app). Google and its partners may use cookies or device identifiers to show and measure ads, including personalised ads where you consent or where the law allows. You can manage this in your',
    'privacy.googleSettings': 'Google ad settings',
    'privacy.p2b':
        ', and learn how Google uses data from sites that use its services at',
    'privacy.p3':
        'The one-time lifetime unlock in the phone app removes all ads.',
    'privacy.micTitle': 'Microphone (party mode)',
    'privacy.mic':
        'Party mode is optional and off by default. When you turn it on, your browser or phone asks for the microphone so the tomato can hear the music nearby. The sound is analysed on your device to find the beat and is never recorded, stored or sent anywhere. Turn it off at any time.',
    'privacy.purchasesTitle': 'Purchases',
    'privacy.purchases':
        'Purchases and the optional tip link are handled by Apple, Google or the tip service you choose. We never see your payment details.',
    'privacy.ageTitle': 'Age',
    'privacy.age':
        'Tomato Pop is suitable for all ages. It does not knowingly collect personal information from anyone, including children.',
    'privacy.changesTitle': 'Changes to this policy',
    'privacy.changes':
        'We may update this policy from time to time. The date below shows the latest version.',
    'privacy.contactTitle': 'Contact us',
    'privacy.contact': 'If you have any questions about this policy, write to',
    'privacy.updated': 'Last updated: {date}',
    'timer.roulette': 'Nap roulette',
    'timer.unknownClock': '??:??',
    'page.rouletteBoom': 'Wake up! 💥',
    'notify.focus': 'Focus session complete! Time for a break 🍅',
    'notify.break': 'Break is over. Ready for the next one?',
    'notify.running': 'Timer running – ends at {time}',
    'notify.cancel': 'Cancel',
    'notify.roulette': 'Wake up! 💥',
    'drawer.roulette': 'Nap roulette: goes off at a random moment',
    'drawer.minutes.rouletteMin': 'At least',
    'drawer.minutes.rouletteMax': 'At most',
    'page.streakNone': '🔥 Start a streak',
    'streak.title': 'Daily streak',
    'streak.close': 'Close',
    'streak.days': '{count} day streak',
    'streak.status.none':
        'No streak yet. Finish a focus session to light the flame.',
    'streak.status.done': "You're done for today. Your streak is safe 🔥",
    'streak.status.open': 'Finish one focus session today to keep it going.',
    'streak.status.rest': "It's the weekend: rest up. Your streak is safe 😴",
    'streak.how.title': 'How it works',
    'streak.how.1':
        'Finish at least one focus session in a day and your streak grows by one.',
    'streak.how.2':
        'Weekends are for resting. Saturdays and Sundays never break your streak, and a session on one still counts.',
    'streak.how.3': 'Skip a weekday and the streak starts over.',
    'streak.popup': '🔥 {count} days!',
    'streak.gift.title': '🍀 Lucky you!',
    'streak.gift.body':
        'Your {count}-day streak slipped away, but the tomato gods are feeling generous today. Watch a short video and it comes right back.',
    'streak.gift.accept': 'Bring it back',
    'streak.gift.decline': 'Let it go',
    'streak.gift.retry':
        'The video was closed early. Try again to get your streak back.',
    'streak.gift.back': '🔥 {count} day streak is back!',
    'drawer.streakReminders': 'Streak reminders',
    'drawer.streakRemindersHint':
        'A nudge on weekday evenings to keep your streak going. Never on weekends.',
    'streak.notify.title': 'Tomato Pop 🍅',
    'streak.notify.keep.0':
        '🔥 Your {count}-day streak is counting on you. One tomato keeps it alive!',
    'streak.notify.keep.1':
        "Don't let the flame go out! Squeeze in one focus session to keep your {count}-day streak.",
    'streak.notify.keep.2':
        "🍅 Just 25 minutes between you and day {count}+. You've got this!",
    'streak.notify.keep.3':
        'Your tomato is waiting. Pop one today and the {count}-day streak lives on 🔥',
    'streak.notify.comeback.0':
        'Your tomato misses you 🍅 Come back for a fresh start.',
    'streak.notify.comeback.1':
        'A new streak starts with a single tomato. Ready when you are!',
    'streak.notify.comeback.2':
        'Psst... your tomato has been practicing its explosion. Come watch 💥',
    'streak.notify.congrats.0':
        "🎉 {count} days in a row! Let's keep it rolling today.",
    'streak.notify.congrats.1':
        'Look at you, {count} days strong 🔥 Another tomato today?',
    'streak.notify.congrats.2':
        "🍅 {count}-day streak! You're on fire. Keep going!",
    'streak.notify.milestone':
        "🏆 {count} days in a row! That's a real habit. Come celebrate with your tomato!",
};

export type MessageKey = keyof typeof enUS;
